import React from 'react';
import { SEOAccordion } from '../../components/SEOAccordion';
export function SEOAccordions() {
  return <section className="py-6 bg-background" data-id="element-338">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-3" data-id="element-339">
        <SEOAccordion title="Custom Web Development" defaultOpen={false} rows={[{
        items: [{
          label: 'Alabama',
          href: 'custom-web-development-Alabama.html'
        }, {
          label: 'Hawaii',
          href: 'custom-web-development-Hawaii.html'
        }, {
          label: 'Michigan',
          href: 'custom-web-development-Michigan.html'
        }, {
          label: 'North Carolina',
          href: 'custom-web-development-North-Carolina.html'
        }, {
          label: 'Utah',
          href: 'custom-web-development-Utah.html'
        }]
      }, {
        items: [{
          label: 'Alaska',
          href: 'custom-web-development-Alaska.html'
        }, {
          label: 'Idaho',
          href: 'custom-web-development-Idaho.html'
        }, {
          label: 'Minnesota',
          href: 'custom-web-development-Minnesota.html'
        }, {
          label: 'North Dakota',
          href: 'custom-web-development-North-Dakota.html'
        }, {
          label: 'Vermont',
          href: 'custom-web-development-Vermont.html'
        }]
      }, {
        items: [{
          label: 'Arizona',
          href: 'custom-web-development-Arizona.html'
        }, {
          label: 'Illinois',
          href: 'custom-web-development-Illinois.html'
        }, {
          label: 'Mississippi',
          href: 'custom-web-development-Mississippi.html'
        }, {
          label: 'Ohio',
          href: 'custom-web-development-Ohio.html'
        }, {
          label: 'Virginia',
          href: 'custom-web-development-Virginia.html'
        }]
      }, {
        items: [{
          label: 'Arkansas',
          href: 'custom-web-development-Arkansas.html'
        }, {
          label: 'Indiana',
          href: 'custom-web-development-Indiana.html'
        }, {
          label: 'Missouri',
          href: 'custom-web-development-Missouri.html'
        }, {
          label: 'Oklahoma',
          href: 'custom-web-development-Oklahoma.html'
        }, {
          label: 'Washington',
          href: 'custom-web-development-Washington.html'
        }]
      }, {
        items: [{
          label: 'California',
          href: 'custom-web-development-California.html'
        }, {
          label: 'Iowa',
          href: 'custom-web-development-Iowa.html'
        }, {
          label: 'Montana',
          href: 'custom-web-development-Montana.html'
        }, {
          label: 'Oregon',
          href: 'custom-web-development-Oregon.html'
        }, {
          label: 'West Virginia',
          href: 'custom-web-development-West-Virginia.html'
        }]
      }, {
        items: [{
          label: 'Colorado',
          href: 'custom-web-development-Colorado.html'
        }, {
          label: 'Kansas',
          href: 'custom-web-development-Kansas.html'
        }, {
          label: 'Nebraska',
          href: 'custom-web-development-Nebraska.html'
        }, {
          label: 'Pennsylvania',
          href: 'custom-web-development-Pennsylvania.html'
        }, {
          label: 'Wisconsin',
          href: 'custom-web-development-Wisconsin.html'
        }]
      }, {
        items: [{
          label: 'Connecticut',
          href: 'custom-web-development-Connecticut.html'
        }, {
          label: 'Kentucky',
          href: 'custom-web-development-Kentucky.html'
        }, {
          label: 'Nevada',
          href: 'custom-web-development-Nevada.html'
        }, {
          label: 'Rhode Island',
          href: 'custom-web-development-Rhode-Island.html'
        }, {
          label: 'Wyoming',
          href: 'custom-web-development-Wyoming.html'
        }]
      }, {
        items: [{
          label: 'Delaware',
          href: 'custom-web-development-Delaware.html'
        }, {
          label: 'Louisiana',
          href: 'custom-web-development-Louisiana.html'
        }, {
          label: 'New Hampshire',
          href: 'custom-web-development-New-Hampshire.html'
        }, {
          label: 'South Carolina',
          href: 'custom-web-development-South-Carolina.html'
        }]
      }, {
        items: [{
          label: 'District of Columbia',
          href: 'custom-web-development-District-of-Columbia.html'
        }, {
          label: 'Maine',
          href: 'custom-web-development-Maine.html'
        }, {
          label: 'New Jersey',
          href: 'custom-web-development-New-Jersey.html'
        }, {
          label: 'South Dakota',
          href: 'custom-web-development-South-Dakota.html'
        }]
      }, {
        items: [{
          label: 'Florida',
          href: 'custom-web-development-Florida.html'
        }, {
          label: 'Maryland',
          href: 'custom-web-development-Maryland.html'
        }, {
          label: 'New Mexico',
          href: 'custom-web-development-New-Mexico.html'
        }, {
          label: 'Tennessee',
          href: 'custom-web-development-Tennessee.html'
        }]
      }, {
        items: [{
          label: 'Georgia',
          href: 'custom-web-development-Georgia.html'
        }, {
          label: 'Massachusetts',
          href: 'custom-web-development-Massachusetts.html'
        }, {
          label: 'New York',
          href: 'custom-web-development-New-York.html'
        }, {
          label: 'Texas',
          href: 'custom-web-development-Texas.html'
        }]
      }]} data-id="element-340" />
        <SEOAccordion title="Custom Software Development" defaultOpen={false} rows={[{
        items: [{
          label: 'New York',
          href: 'custom-web-development-New-York-New-York.html'
        }, {
          label: 'Detroit',
          href: 'custom-web-development-Detroit-Michigan.html'
        }, {
          label: 'El Paso',
          href: 'custom-web-development-El-Paso-Texas.html'
        }, {
          label: 'Tucson',
          href: 'custom-web-development-Tucson-Arizona.html'
        }, {
          label: 'Kansas City',
          href: 'custom-web-development-Kansas-City-Missouri.html'
        }]
      }, {
        items: [{
          label: 'Los Angeles',
          href: 'custom-web-development-Los-Angeles-California.html'
        }, {
          label: 'Jacksonville',
          href: 'custom-web-development-Jacksonville-Florida.html'
        }, {
          label: 'Milwaukee',
          href: 'custom-web-development-Milwaukee-Wisconsin.html'
        }, {
          label: 'Albuquerque',
          href: 'custom-web-development-Albuquerque-New-Mexico.html'
        }, {
          label: 'Atlanta',
          href: 'custom-web-development-Atlanta-Georgia.html'
        }]
      }, {
        items: [{
          label: 'Chicago',
          href: 'custom-web-development-Chicago-Illinois.html'
        }, {
          label: 'Indianapolis',
          href: 'custom-web-development-Indianapolis-Indiana.html'
        }, {
          label: 'Boston',
          href: 'custom-web-development-Boston-Massachusetts.html'
        }, {
          label: 'Long Beach',
          href: 'custom-web-development-Long-Beach-California.html'
        }, {
          label: 'Omaha',
          href: 'custom-web-development-Omaha-Nebraska.html'
        }]
      }, {
        items: [{
          label: 'Houston',
          href: 'custom-web-development-Houston-Texas.html'
        }, {
          label: 'Columbus',
          href: 'custom-web-development-Columbus-Ohio.html'
        }, {
          label: 'Seattle',
          href: 'custom-web-development-Seattle-Washington.html'
        }, {
          label: 'Sacramento',
          href: 'custom-web-development-Sacramento-California.html'
        }, {
          label: 'Oakland',
          href: 'custom-web-development-Oakland-California.html'
        }]
      }, {
        items: [{
          label: 'Philadelphia',
          href: 'custom-web-development-Philadelphia-Pennsylvania.html'
        }, {
          label: 'San Francisco',
          href: 'custom-web-development-San-Francisco-California.html'
        }, {
          label: 'Denver',
          href: 'custom-web-development-Denver-Colorado.html'
        }, {
          label: 'Fresno',
          href: 'custom-web-development-Fresno-California.html'
        }, {
          label: 'Honolulu',
          href: 'custom-web-development-Honolulu-Hawaii.html'
        }]
      }, {
        items: [{
          label: 'Phoenix',
          href: 'custom-web-development-Phoenix-Arizona.html'
        }, {
          label: 'Austin',
          href: 'custom-web-development-Austin-Texas.html'
        }, {
          label: 'Washington',
          href: 'custom-web-development-Washington-District-of-Columbia.html'
        }, {
          label: 'New Orleans',
          href: 'custom-web-development-New-Orleans-Louisiana.html'
        }, {
          label: 'Miami',
          href: 'custom-web-development-Miami-Florida.html'
        }]
      }, {
        items: [{
          label: 'San Diego',
          href: 'custom-web-development-San-Diego-California.html'
        }, {
          label: 'Memphis',
          href: 'custom-web-development-Memphis-Tennessee.html'
        }, {
          label: 'Portland',
          href: 'custom-web-development-Portland-Oregon.html'
        }, {
          label: 'Mesa',
          href: 'custom-web-development-Mesa-Arizona.html'
        }, {
          label: 'Tulsa',
          href: 'custom-web-development-Tulsa-Oklahoma.html'
        }]
      }, {
        items: [{
          label: 'San Antonio',
          href: 'custom-web-development-San-Antonio-Texas.html'
        }, {
          label: 'Fort Worth',
          href: 'custom-web-development-Fort-Worth-Texas.html'
        }, {
          label: 'Las Vegas',
          href: 'custom-web-development-Las-Vegas-Nevada.html'
        }, {
          label: 'Cleveland',
          href: 'custom-web-development-Cleveland-Ohio.html'
        }, {
          label: 'Colorado Springs',
          href: 'custom-web-development-Colorado-Springs-Colorado.html'
        }]
      }, {
        items: [{
          label: 'Dallas',
          href: 'custom-web-development-Dallas-Texas.html'
        }, {
          label: 'Baltimore',
          href: 'custom-web-development-Baltimore-Maryland.html'
        }, {
          label: 'Oklahoma City',
          href: 'custom-web-development-Oklahoma-City-Oklahoma.html'
        }, {
          label: 'Virginia Beach',
          href: 'custom-web-development-Virginia-Beach-Virginia.html'
        }, {
          label: 'Minneapolis',
          href: 'custom-web-development-Minneapolis-Minnesota.html'
        }]
      }, {
        items: [{
          label: 'San Jose',
          href: 'custom-web-development-San-Jose-California.html'
        }, {
          label: 'Charlotte',
          href: 'custom-web-development-Charlotte-North-Carolina.html'
        }, {
          label: 'Nashville',
          href: 'custom-web-development-Nashville-Tennessee.html'
        }, {
          label: 'Kansas City',
          href: 'custom-web-development-Kansas-City-Kansas.html'
        }, {
          label: 'Arlington',
          href: 'custom-web-development-Arlington-Texas.html'
        }]
      }]} data-id="element-341" />
      </div>
    </section>;
}